import { render, staticRenderFns } from "./SpectatingWarningBar.vue?vue&type=template&id=16226666&scoped=true&"
import script from "./SpectatingWarningBar.vue?vue&type=script&lang=js&"
export * from "./SpectatingWarningBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16226666",
  null
  
)

export default component.exports